import { useRef, useEffect, useState } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Button } from "@/components/ui/button";
import { Eraser, Check } from "lucide-react";

const SignaturePad = ({ onSave, initialValue, label = "Signature" }) => {
  const sigRef = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);

  useEffect(() => {
    if (initialValue && sigRef.current) {
      sigRef.current.fromDataURL(initialValue);
      setIsEmpty(false);
    }
  }, [initialValue]);

  const handleClear = () => {
    sigRef.current.clear();
    setIsEmpty(true);
    onSave(null);
  };

  const handleEnd = () => {
    if (sigRef.current) {
      const dataUrl = sigRef.current.toDataURL("image/png");
      setIsEmpty(sigRef.current.isEmpty());
      onSave(dataUrl);
    }
  };

  return (
    <div className="space-y-3" data-testid={`signature-pad-${label.toLowerCase().replace(/\s/g, "-")}`}>
      <label className="block text-sm font-medium text-slate-700">{label}</label>
      <div className="relative">
        <SignatureCanvas
          ref={sigRef}
          penColor="#0f172a"
          canvasProps={{
            className: "signature-canvas w-full h-40",
            style: { touchAction: "none" },
          }}
          onEnd={handleEnd}
        />
        <div className="absolute bottom-2 right-2 flex gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={handleClear}
            className="h-8 px-3"
            data-testid="signature-clear"
          >
            <Eraser className="w-4 h-4 mr-1" />
            Effacer
          </Button>
        </div>
      </div>
      {!isEmpty && (
        <p className="text-sm text-green-600 flex items-center gap-1">
          <Check className="w-4 h-4" />
          Signature enregistrée
        </p>
      )}
    </div>
  );
};

export default SignaturePad;
